<template>
  <Dialog ref="dialog" :config="config" :visible='visible' :cancelDialog="cancelDialogs" :confirmDialog='importConfirm' :isdeling='isdeling'>
    <!-- <priview-pdf :pdfUrl="pdfUrl"></priview-pdf> -->
    <div class="main-section" id="content" ref="contentDiv" v-loading='loading'></div>
    存储位置：增值税销项电子发票目录/2021年/07月
  </Dialog>
</template>

<script>
  import Dialog from "@/components/Dialog";
  import PriviewPdf from "@/components/PriviewPdf";
  // import {parseOfdDocument, renderOfd} from "ofd.js";
  export default {
    props: {
      period: {
        type: String,
      },
      visible: {
        type: Boolean,
      },
      cancelDialog: {
        type: Function,
        default: () => { },
      },
    },
    components: {
      Dialog,
      PriviewPdf
    },
    data() {
      return {
        // pdfUrl: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf',
        pdfUrl: '/static/test.pdf',
        // pdfUrl: '/static/test.ofd',

        fileUrl : 'https://51shouzu.xyz/ofd/999.ofd',
        config: {
          top: '10vh',
          width: '46rem',
          type: 'PDF',
          title: '042002000211_60278288_20201214.ofd',
          center: true,
          btnTxt: [],
        },
        fileList: [],
        fileData: '',
        isdeling: false,
        tableData: [],
        status:  false,
        message : '请选择上传文件',
        screenWidth :'840',
        loading : false,
      };
    },
    methods: {
      cancelDialogs(){
        this.cancelDialog();
      },
      importConfirm(){
        this.cancelDialog();
      },
      getOfdDocumentObj(file, screenWidth) {
          let that = this;
          let t = new Date().getTime();
          this.loading = true;
          // parseOfdDocument({
          //   ofd: file,
          //   success(res) {
          //     let t1 = new Date().getTime();
          //     console.log('解析ofd',t1 - t);
          //     that.ofdObj = res[0];
          //     that.pageCount = res[0].pages.length;
          //     const divs = renderOfd(screenWidth, res[0]);
          //     let t2 = new Date().getTime();
          //     console.log('xml转svg', t2 - t1)
          //     that.displayOfdDiv(divs);
          //     let t3 = new Date().getTime();
          //     console.log('svg渲染到页面', t3 - t2);
          //     that.loading = false;
          //   },
          //   fail(error) {
          //     that.loading = false;
          //     that.$alert('OFD打开失败', error, {
          //       confirmButtonText: '确定',
          //       callback: action => {
          //         einvAlert.warning("提示",`action: ${ action }`);
          //       }
          //     });
          //   }
          // });
        },

      displayOfdDiv(divs) {
        let contentDiv = document.getElementById('content');
        contentDiv.innerHTML = '';
        for (const div of divs) {
          contentDiv.appendChild(div)
        }
    },

    // fileChanged() {
    //   this.file = this.$refs.file.files[0];
    //   let ext = this.file.name.replace(/.+\./, "");
    //   if (["ofd"].indexOf(ext) === -1) {
    //     this.$alert('error', '仅支持ofd类型', {
    //       confirmButtonText: '确定',
    //       callback: action => {
    //         einvAlert({
    //           type: 'info',
    //           message: `action: ${ action }`
    //         });
    //       }
    //     });
    //     return;
    //   }
    //   if (this.file.size > 100 * 1024 * 1024) {
    //     this.$alert('error', '文件大小需 < 100M', {
    //       confirmButtonText: '确定',
    //       callback: action => {
    //         einvAlert({
    //           type: 'info',
    //           message: `action: ${ action }`
    //         });
    //       }
    //     });
    //     return;
    //   }
    //   let that = this;
    //   let reader = new FileReader();
    //   reader.readAsDataURL(this.file);
    //   reader.onload = function (e) {
    //     that.ofdBase64 = e.target.result.split(',')[1];
    //   }
    //   this.getOfdDocumentObj(this.file, this.screenWidth);
    //   this.$refs.file.value = null;
    // },
      demo() {
        let ofdFile = '/static/test.ofd';
        this.getOfdDocumentObj(ofdFile, this.screenWidth);
      },
    },
    // mounted(){
    //   this.getOfdDocumentObj(this.fileUrl, this.screenWidth);
    // },
    watch:{
      visible(val){
        if(val){
          this.demo();
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .firstStep {
    margin: 24px 0 12px;
  }
  .upload {
    cursor: pointer;
    color: #4f71ff;
  }
  .main-section{
    min-height: 500px;
  }
</style>
